import { isBlankMessageContent } from '@shared';

/**
 * What the composer sends for a typed input (SB-3538 T4). Blank input —
 * whitespace, or only zero-width and other invisible characters — is sent as
 * exactly `''`: the user bubble hides only on empty content, and the API's
 * empty-send rule reads blank the same way. Anything visible is sent as typed.
 */
export const toSendableMessageContent = (input: string): string =>
  isBlankMessageContent(input) ? '' : input;

/** Whether the send is blocked because text is required and none is visible. */
export const isPromptTextMissing = (
  required: boolean,
  input: string,
): boolean => required && isBlankMessageContent(input);
